import { base, IObject } from "@quest/base-core";
import { reelPanel, slot } from "@quest/slot-core";
import { BehaviorCoreModule } from "@quest/murka-games-behavior-leopard/dist";

//  BASE GAME
import { BaseControllerGame } from "./Base/BaseControllerGame";
import { BaseGameViewGame } from "./Base/BaseGameViewGame";
import { MetersControllerGame } from "./Base/MetersControllerGame";
import { ButtonControllerGame } from "./Base/ButtonControllerGame";
import { ReelPanelControllerGame } from "./Base/ReelPanelControllerGame";
import { WinPresentationControllerGame } from "./Base/WinPresentationControllerGame";
import { BaseGameModel } from "./model/BaseGameModel";
import { GameClientLogic } from "./Logic/GameClientLogic";
import { gameConstants } from "./Constants/gameConstants";
import { SettingPanelControllerGame } from "./Base/SettingPanelControllerGame";

//  INTRO OUTRO
import { IntroOutroControllerGame } from "./IntroOutro/IntroOutroControllerGame";

// BIG WIN
import { BigWinControllerGame } from "./BigWin/BigWinControllerGame";

//blur background
import { BlurBackgroundControllerGame } from "./BlurBackground/BlurBackgroundController";

// FREE GAME
import { View } from "./FreeGame/View";
import { FreeGameControllerGame } from "./FreeGame/FreeGameControllerGame";
import { FreeGameReelPanelControllerGame } from "./FreeGame/FreeGameReelPanelController";
import { BackgroundControllerGame } from "./Background/BackgroundControllerGame";
import { FreeGameWinPresentationControllerGame } from "./FreeGame/FreeGameWinPresentationControllerGame";
import { ReelGame } from "./ReelPanel/Reel";
import { WinPresentationPanelGame } from "./ReelPanel/WinPresentationPanel";
import { FreeGameModel } from "./model/FreeGameModel";
import { PaylinesGame } from "./ReelPanel/Paylines";
import { GameIntroControllerGame } from "./GameIntro/GameIntroControllerGame";
import { BottomBarControllerGame } from "./BottomBar/BottomBarControllerGame";
import { GameIntroViewGame } from "./GameIntro/GameIntroViewGame";
import { BottomBarViewGame } from "./BottomBar/BottomBarViewGame";
import { BigWinViewGame } from "./BigWin/BigWinViewGame";
import { ReelPanelGame } from "./ReelPanel/ReelPanelGame";
import { AutoPlayPopUpControllerGame } from "./AutoPlayPopUp/AutoPlayPopUpControllerGame";
import { PlayerMsgControllerGame } from "./playermessage/PlayerMsgControllerGame";
import { PlayerMsgViewGame } from "./playermessage/PlayerMsgViewGame";
import { DeviceDetectorGame } from "./DeviceDetectorGame";
import { FreeGameButtonControllerGame } from "./FreeGame/FreeGameButtonControllerGame";
import { AutoPlayPopUpViewGame } from "./AutoPlayPopUp/AutoPlayPopUpViewGame";
import { BackgroundViewGame } from "./Background/BackgroundViewGame";
import { BaseViewGame } from "./BaseViewGame";
import { IntroOutroViewGame } from "./IntroOutro/IntroOutroViewGame";

// This is only for adding coreModuleList in final game js else use gameConstants directly//
export let game: IObject = {
  gameConstants: gameConstants,
};
BehaviorCoreModule.AutoPlayPopUpController = AutoPlayPopUpControllerGame;
BehaviorCoreModule.Paylines = PaylinesGame;
BehaviorCoreModule.GameIntroController = GameIntroControllerGame;
BehaviorCoreModule.GameIntroView = GameIntroViewGame;
BehaviorCoreModule.BottomBarController = BottomBarControllerGame;
BehaviorCoreModule.BottomBarView = BottomBarViewGame;
BehaviorCoreModule.FreeGameController = FreeGameControllerGame;
BehaviorCoreModule.FreeGameView = View;
BehaviorCoreModule.BaseController = BaseControllerGame;
BehaviorCoreModule.BaseView = BaseGameViewGame;
BehaviorCoreModule.IntroOutroController = IntroOutroControllerGame;
BehaviorCoreModule.SettingPannelController = SettingPanelControllerGame;
BehaviorCoreModule.FreeGameButtonController = FreeGameButtonControllerGame;
slot.SlotLogic = GameClientLogic;
slot.BaseWinPresentationController = WinPresentationControllerGame;
slot.BaseReelPanelController = ReelPanelControllerGame;
slot.BaseMetersController = MetersControllerGame;
slot.BaseButtonController = ButtonControllerGame;
BehaviorCoreModule.FreeGameView = View;
BehaviorCoreModule.BigWinController = BigWinControllerGame;
BehaviorCoreModule.BigWinView = BigWinViewGame;
BehaviorCoreModule.FreeGameReelPanelController = FreeGameReelPanelControllerGame;
BehaviorCoreModule.BaseModel = BaseGameModel;
BehaviorCoreModule.BackgroundController = BackgroundControllerGame;
BehaviorCoreModule.FreeGameWinPresentationController = FreeGameWinPresentationControllerGame;
reelPanel.Reel = ReelGame;
reelPanel.WinReelPanel = WinPresentationPanelGame;
BehaviorCoreModule.BlurBackgroundController = BlurBackgroundControllerGame;
BehaviorCoreModule.FreeGameModel = FreeGameModel;
reelPanel.ReelPanel = ReelPanelGame;
BehaviorCoreModule.PlayerMsgController = PlayerMsgControllerGame;
BehaviorCoreModule.PlayerMsgView = PlayerMsgViewGame;
BehaviorCoreModule.AutoPlayPopUpView = AutoPlayPopUpViewGame;
BehaviorCoreModule.BackGroundView = BackgroundViewGame;
base.DetectDeviceEnvironment = DeviceDetectorGame
base.BaseView = BaseViewGame
BehaviorCoreModule.IntroOutroView = IntroOutroViewGame;



